const NavMenuLangSelector = {

  _isExpanded: false,

  _selectors: {
    mobileBottomNav: '.js-mobile-bottom-nav',
    container: '.js-lang-selector',
    currentLangBtn: '.js-btn-lang-selector'
  },

  init() {
    document
      .querySelector(this._selectors.mobileBottomNav)
      .querySelector(this._selectors.currentLangBtn)
      .addEventListener('click', this.handleClick.bind(this))
    ;
  },

  handleClick() {
    if (this._isExpanded) {
      this.collapse();
    } else {
      this.expand();
    }
  },

  expand() {
    const self = this;

    document
      .querySelector(this._selectors.mobileBottomNav)
      .classList.add('lang-activated')
    ;

    // Adds timeout to avoid triggering collapse event
    setTimeout(() => {
      self._isExpanded = true;
    });
  },

  collapse() {
    document
      .querySelector(this._selectors.mobileBottomNav)
      .classList.remove('lang-activated')
    ;

    this._isExpanded = false;
  }
};

export default NavMenuLangSelector;